import { createAction } from '@reduxjs/toolkit';

import { SET_TEXT_STRINGS } from './types';

export type TextStrings = {
    [key: string]: string,
};

export const setTextStrings = createAction<TextStrings>(SET_TEXT_STRINGS);
